<template>
  <div>
    <!-- Отображение оставшегося времени -->
    <p v-if="timeRemaining > 0">
      {{ formatTime(timeRemaining) }}
    </p>
    <p v-else>0</p>
  </div>
</template>

<script>
import { ref, computed } from 'vue'

export default {
  name:'trip-work-timer',
  props: ['startTime'],
  setup(props) {
    // const currentTime = ref(new Date())
    const currentTimeLocal = ref(new Date())
    const timezoneOffsetMsk = currentTimeLocal.value.getTimezoneOffset()*60*1000 + 3*60*60*1000

    const endTime = computed(() => {
      const startTime = new Date(props.startTime)
      return new Date(startTime.getTime() + 90 * 60 * 1000) // 90 минут
    })

    
    // Расчет оставшегося времени в миллисекундах
    const timeRemaining = computed(() => endTime.value - currentTimeLocal.value + Math.abs(timezoneOffsetMsk))
    // const timeRemaining = computed(() => endTime.value - currentTime.value)

    // Функция для форматирования времени (в данном случае в минуты и секунды)
    const formatTime = (time) => {
      const minutes = Math.floor(time / 60000)
      const seconds = ((time % 60000) / 1000).toFixed(0)
      return `${minutes}:${seconds}`
    }

    // Обновление текущего времени каждую секунду
    setInterval(() => {
      currentTimeLocal.value = new Date()
      // currentTime.value = new Date()
    }, 1000)

    return {
      timeRemaining,
      formatTime,
    }
  },
}
</script>
